
import "./AllLocation.scss";
import { useSelector } from "react-redux";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Popover
} from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { GridLoader, ScaleLoader } from "react-spinners";
import { MdAdd, MdClose } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoMdArrowForward, IoMdArrowBack } from "react-icons/io";
import { CustomButtonSmallDarkBg, CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { SiOpenlayers } from "react-icons/si";



const AllLocation = ({ title, desc, menu_icon }) => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [savingTitle, setSavingTitle] = useState("Save");
  const [searchTerm, setSearchTerm] = useState("");

  const [originalPageTitle, setOriginalPageTitle] = useState(title);
  const [originalPageDesc, setOriginalPageDesc] = useState(desc);

  const [pageTitle, setPageTitle] = useState(title);
  const [pageDesc, setPageDesc] = useState(desc);


  const [currencyAction, setCurrencyAction] = useState("");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [img, setImg] = useState(null);
  const [selectedAdminToAdd, setSelectedAdminToAdd] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [hierachies, setHierachies] = useState([]);
  const [selectedHierachy, setSelectedHierachy] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleUploadDoalogClose = () => {
    setIsUploadDialogOpen(false);
  };


  const [currentHierachyPage, setCurrentHierachyPage] = useState(0);
  const handleHierachiesPageChange = (event, newPage) => {
    setCurrentHierachyPage(newPage);
  };

  const slicedHierachies = hierachies.slice(
    currentHierachyPage * rowsPerPage,
    currentHierachyPage * rowsPerPage + rowsPerPage
  );


  const handleSearchHierachy = async () => {
    try {
      if (searchTerm) {
        setIsLoading(true);
        const res = await newRequest.post("/location/search", { search_input: searchTerm });
        setHierachies(res.data);
      } else {
        setPageTitle(originalPageTitle);
        setPageDesc(originalPageDesc);
        await fetchHierachyLevels();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleHierachiesRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentHierachyPage(0);
  };

  const fetchHierachyLevels = async () => {
    try {
      const res = await newRequest.post(
        "/location/findAll", { loc_type: "county", result_limit: 100 }
      );
      setHierachies(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchHierachyChildren = async (parentCode, levelType) => {
    try {
      setIsLoading(true);
      // console.log(`fetchHierachyChildren  ${JSON.stringify({ loc_parent_code: parentCode, loc_type: levelType }, null, 2)}`);
      const res = await newRequest.post(
        "/location/locationChildren", { loc_parent_code: parentCode, loc_type: levelType }
      );
      setHierachies(null);
      setHierachies(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteHierachy") {

      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };


  const whenViewMounts = async () => {
    try {
      setIsLoading(true);
      fetchHierachyLevels();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    whenViewMounts();
  }, []);

  const handleHierachiesChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...hierachies];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      setHierachies(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleHierachiesBlur = async (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...hierachies];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      const updatePayload = {
        [name]: value,
        updatedBy: currentUser.usr_id,
      };

      const res = await newRequest.put(`/location/upd/${rowId}`, updatePayload);


    } catch (error) {
      console.log(error);
    }
  };

  const handleHierachyAction = async () => {
    try {


    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  return (
    <div className="location">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="location-main-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="location-toolbar">
            <div className="left">
              <div className="search-input-wrapper" style={{ width: "100%%x" }}>
                <FiSearch className="search-input-icon" />
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search location..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchHierachy();
                  }}
                />
                {searchTerm.length > 0 && (
                  <MdClose
                    onClick={async (e) => {
                      try {
                        setSearchTerm("");
                        setPageTitle(originalPageTitle);
                        setPageDesc(originalPageDesc);
                        await fetchHierachyLevels();
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
                {searchTerm.length === 0 && (
                  <span className="search-input-icon" />
                )}
              </div>
            </div>
            <div className="right">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                endIcon={<MdAdd />}
                aria-describedby={id}
                onClick={handlePopoverClick}
              >
                New Level
              </CustomLoadingButton>
            </div>
          </div>
          <div className="location-content">
            <div className="table-view">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto", display: 'flex' }}>
                          <span>NAME</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>CODE</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>TYPE</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>REFERENCE</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {slicedHierachies?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedHierachy?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedHierachy(row);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentHierachyPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", display: "flex", flexDirection: "row", gap: "20px" }}>
                            <span style={{ fontWeight: "400", fontSize: "18px" }}>{row.loc_name}</span>
                            {row.loc_type !== "ward" &&
                              <CustomButtonSmallDarkBg
                                currentTheme={currentTheme}
                                endIcon={<IoMdArrowForward />}
                                iconPosition={"end"}
                                height={"32px"}
                                border={false}
                                aria-describedby={id}
                                onClick={async () => {
                                  try {
                                    const newTitle = `${row.loc_name} ${row.next_loc_label_xx}`;
                                    setPageTitle(newTitle.toUpperCase());
                                    setPageDesc(row.loc_name);
                                    await fetchHierachyChildren(row.loc_code, row.next_loc_code_xx);

                                    setCurrentHierachyPage(0);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              >
                                {row?.next_loc_label_xx}
                              </CustomButtonSmallDarkBg>}
                            {row.loc_type === "ward" &&
                              <CustomButtonSmallDarkBg
                                currentTheme={currentTheme}
                                iconPosition="end"
                                startIcon={<IoMdArrowBack />}
                                height={"32px"}
                                border={false}
                                aria-describedby={id}
                                onClick={async () => {
                                  try {
                                    setPageTitle(originalPageTitle);
                                    setPageDesc(originalPageDesc);
                                    await fetchHierachyLevels();

                                    setCurrentHierachyPage(0);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              >
                                Back
                              </CustomButtonSmallDarkBg>}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className="sub-title">{row.loc_code}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className="sub-title">{row.loc_type}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className="sub-title">{row.loc_reference}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {hierachies?.length > rowsPerPage
                    && <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleHierachiesRowsPerPage}
                      component="div"
                      count={hierachies?.length}
                      rows={hierachies}
                      page={currentHierachyPage}
                      onPageChange={handleHierachiesPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          {/* End ofNumber Generation */}
          <Popover
            id={id}
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div style={{ padding: "20px" }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "max-content",
                marginBottom: "5px"
              }}>
                <span>ADD NUMBER GEN</span>
                <span
                  onClick={handlePopoverClose}
                >
                  <MdClose
                    style={{
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                  />
                </span>
              </div>
              Content
            </div>
          </Popover>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={handleCloseNotifyDialog}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={handleCloseNotifyDialog}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}

    </div>
  );
};

export default AllLocation;
